module.exports = __webpack_public_path__ + "img/one-window-statement.9035f5d3.png";